import * as React from 'react';

import { SharedUiStickyBookBarWrapper } from 'components/infosite/shared-ui/offers/shared-ui-property-sticky-book-bar';

export const StickyBookBar: React.FC<Record<string, unknown>> = () => <SharedUiStickyBookBarWrapper />;
